import { render, staticRenderFns } from "./RestoreCartItems.vue?vue&type=template&id=65f3b4d0&scoped=true"
import script from "./RestoreCartItems.vue?vue&type=script&lang=js"
export * from "./RestoreCartItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3b4d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f3b4d0')) {
      api.createRecord('65f3b4d0', component.options)
    } else {
      api.reload('65f3b4d0', component.options)
    }
    module.hot.accept("./RestoreCartItems.vue?vue&type=template&id=65f3b4d0&scoped=true", function () {
      api.rerender('65f3b4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/RestoreCartItems.vue"
export default component.exports